import { Controller } from 'stimulus';

class AmountOfPersonsController extends Controller {
  connect() {
    this.amountOfJourneyCartItems = parseInt(this.data.get('journey-cart-items'), 10);

    if (this.hasAmountOfAdultsTarget) {
      this.amountOfAdults = parseInt(this.amountOfAdultsTarget.value, 10);
    }

    if (this.hasAmountOfChildrenTarget) {
      this.amountOfChildren = parseInt(this.amountOfChildrenTarget.value, 10);
    }

    if (this.hasAmountOfBabiesTarget) {
      this.amountOfBabies = parseInt(this.amountOfBabiesTarget.value, 10);
    }
  }

  onInputChange(e) {
    this.storeAmountOfPersonsInSession();

    if (!this.amountOfJourneyCartItems) {
      return;
    }

    const amount = parseInt(e.currentTarget.value, 10);

    if (e.currentTarget === this.amountOfAdultsTarget && this.amountOfAdults !== amount) {
      this.openModal();
    }

    if (e.currentTarget === this.amountOfChildrenTarget && this.amountOfChildren !== amount) {
      this.openModal();
    }

    if (e.currentTarget === this.amountOfBabiesTarget && this.amountOfBabies !== amount) {
      this.openModal();
    }
  }

  onContinueClick() {
    this.removeJourneyCartItems()
      .then((res) => {
        this.amountOfJourneyCartItems = res.count;
      })
      .then(() => this.closeModal());
  }

  onCancelClick() {
    this.cancel();
  }

  cancel() {
    this.resetInputs();
    this.closeModal();
  }

  resetInputs() {
    this.amountOfAdultsTarget.value = this.amountOfAdults;
    this.amountOfChildrenTarget.value = this.amountOfChildren;
    this.amountOfBabiesTarget.value = this.amountOfBabies;

    this.storeAmountOfPersonsInSession();
  }

  openModal() {
    $(this.modalTarget).modal('show');
  }

  closeModal() {
    $(this.modalTarget).modal('hide');
  }

  storeAmountOfPersonsInSession() {
    return $.ajax(window.app.api.session, {
      type: 'POST',
      data: {
        amount_of_adults: this.amountOfAdultsTarget.value,
        amount_of_children: this.amountOfChildrenTarget.value,
        amount_of_babies: this.amountOfBabiesTarget.value,
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  removeJourneyCartItems() {
    return $.ajax(window.app.api.journeyCartItemDestroy, {
      type: 'POST',
    });
  }
}

AmountOfPersonsController.targets = [
  'amountOfAdults',
  'amountOfChildren',
  'amountOfBabies',
  'modal',
];

export default AmountOfPersonsController;
